"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { useUser } from "@clerk/nextjs";
import { trackEvent } from "@/lib/analytics";

/**
 * Meldet `membership_signup_completed` fuer Registrierungen mit Google.
 *
 * AuthCard meldet nur den E-Mail-Code-Weg. Google-Registrierungen laufen
 * ueber `/sso-callback` (oder den Transfer in GoogleSignInButton), dort gibt
 * es keinen Moment, in dem "neues Konto" feststeht — Clerk leitet nur weiter.
 * Beide Wege haengen bei neuen Konten `initial=true` an das Ziel; daran und
 * an einem frischen `createdAt` erkennen wir die Registrierung hier.
 *
 * Kein Doppelzaehlen mit AuthCard: Dort entstandene Konten haben kein
 * Google-Konto verknuepft. Ein Reload zaehlt nicht erneut (localStorage pro
 * User). Bewusst ohne das Praefix `dialetics_`: Das raeumt der Logout weg.
 *
 * Abhaengig vom Pfad, nicht nur vom Mount: Clerk navigiert nach dem
 * Callback clientseitig, die Providers bleiben dabei gemountet.
 */
const MAX_ACCOUNT_AGE_MS = 15 * 60 * 1000;

export function OAuthSignUpTracker() {
  const { user } = useUser();
  const pathname = usePathname();

  useEffect(() => {
    if (!user?.createdAt) return;
    if (new URLSearchParams(window.location.search).get("initial") !== "true") return;
    if (Date.now() - user.createdAt.getTime() > MAX_ACCOUNT_AGE_MS) return;
    if (!user.externalAccounts.some((a) => a.provider === "google")) return;

    const key = `ga_sign_up_${user.id}`;
    try {
      if (localStorage.getItem(key) !== null) return;
      localStorage.setItem(key, "1");
    } catch {
      // Ohne Storage lieber einmal zu viel zaehlen als gar nicht.
    }

    trackEvent("membership_signup_completed", { method: "google" }, { userId: user.id });
  }, [user, pathname]);

  return null;
}
